import { render, staticRenderFns } from "./ProductSalesSlide.vue?vue&type=template&id=4ef44c02&"
import script from "./ProductSalesSlide.vue?vue&type=script&lang=js&"
export * from "./ProductSalesSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports